import { FilterName } from "@faire/retailer-visitor-shared/components/Filters/FilterName";
export var getSDUIFilterName = function(view_display_page) {
    if (view_display_page === "CATEGORY_PAGE") {
        return FilterName.LOGGED_IN_CATEGORY;
    }
    return FilterName.UNKNOWN;
};
